export default "__VITE_ASSET__CNQeTQPK__"